<template>
	<div class="scrollable only-y">
		<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-whatsapp widget-icon accent-text fs-30"></i> {{ $t('menu.wa_connect') }}</h2>
			</div>
		</el-col>

		<el-dialog title="Select company" :visible.sync="modalcustomerlist" style="width: 100%;">
            <template>
				<el-input
					class="search-customer mb-10 fl-l" style="width:100%;"
					prefix-icon="el-icon-search"
					placeholder="Search Customer Name"
					clearable
					@keypress.native="doSearchCustomer"
					@clear="doSearchCustomer"
					@keyup.native="doSearchCustomer"
					v-model="searchCustomer" debounce="500">
				</el-input>
				
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateConsumen"
					:current-page="currentConsumenPage"
					:total="parseInt(total)">
				</el-pagination>
				<el-table
					:data="consumen"
					style="width: 100%">
					<el-table-column
						property="customer_name"
						label="Company Name">
					</el-table-column>
					<!-- <el-table-column
						property="customer_pic_email"
						label="PIC">
					</el-table-column> -->
					<!-- <el-table-column
						property="customer_pic_phone"
						label="PIC Phone">
					</el-table-column> -->
					<el-table-column
						label="Operations">
						<template slot-scope="scope">
							<el-button
							size="mini"
							@click="handleChoose(scope.$index, scope.row)">Choose</el-button>
						</template>
						</el-table-column>
				</el-table>
			</template>
        </el-dialog>

		<el-dialog title="Add Service" :visible.sync="dialogFormVisible">
            <el-form ref="form" label-width="160px">
				<el-form-item label="Company">
                    <template>
						<el-button @click="modalcustomerlist=true" v-if="service.companyName==''">
							Add company
						</el-button>
						<div v-else>
							<el-input readonly v-model="service.companyName" style="width: 250px;" class="mr-10"></el-input>
							<el-button type="warning" @click="modalcustomerlist=true" icon="el-icon-edit" rounded>
							</el-button>
							<el-button type="danger" @click="handleDel" icon="el-icon-delete" rounded>
							</el-button>
						</div>
                        <!-- <el-select v-model="service.companyName" placeholder="Select company" style="width:100%;">
                            <el-option
                            v-for="(item, key) in consumen"
                            :key="key"
                            :label="item.customer_name"
                            :value="item.customer_name">
                            </el-option>
                        </el-select> -->
                    </template>
                </el-form-item>
				<el-form-item label="FBBM ID">
					<el-row>
						<el-col :span="12">
							<el-select @change="handleselectfbbm" v-model="fbbm_id" filterable placeholder="Select FBBM ID" style="width:100%;">
									<el-option
									v-for="(item, key) in fbIdentintyFbbm"
									:key="key"
									:label="item.maskingName || '-'"
									:value="item">
									</el-option>
							</el-select>
						</el-col>
						<el-col :span="12"><el-input disabled v-model="fbbm_name" ></el-input></el-col>
					</el-row>
                </el-form-item>
				<el-form-item label="WABA ID">
					<el-row>
						<el-col :span="12">
							<el-select @change="handleselectwaba" v-model="waba_id" filterable placeholder="Select WABA ID" style="width:100%;">
									<el-option
									v-for="(item, key) in fbIdentintyWaba"
									:key="key"
									:label="item.maskingName || '-'"
									:value="item">
									</el-option>
							</el-select>
						</el-col>
						<el-col :span="12"><el-input disabled v-model="waba_name" ></el-input></el-col>
					</el-row>
                </el-form-item>

				
                <el-form-item label="Service Name">
                    <el-input v-model="service.name" placeholder="Service name"></el-input>
                </el-form-item>
				<el-form-item label="Phone Number">
                    <el-input v-model="service.phone_number" placeholder="Phone number"></el-input>
                </el-form-item>
				<el-form-item label="Disable Check Contact">
                    <el-radio-group v-model="service.disable_check_contact">
						<el-radio :label="`true`">True</el-radio>
						<el-radio :label="`false`">False</el-radio>
					</el-radio-group>
                </el-form-item>
				<el-form-item label="Server">
                    <el-radio-group v-model="server">
						<el-radio :label="`dkd`">DKD</el-radio>
						<el-radio :label="`cloud`">Cloud</el-radio>
						<el-radio :label="`on_client`">On Client</el-radio>
					</el-radio-group>
                </el-form-item>
				
				<el-form-item v-if="server != 'cloud'" label="Service IP">
                    <el-input v-model="service.ip" placeholder="Insert service ip"></el-input>
                </el-form-item>

				<el-form-item v-if="server != 'cloud'" label="Service Port">
                    <el-input v-model="service.port" placeholder="Insert service port"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="addService" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisible=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

		<el-dialog title="Edit Service" :visible.sync="dialogFormVisibleEdit">
            <el-form ref="form" label-width="160px">
				<el-form-item label="Company *">
                    <template>
						<el-button @click="modalcustomerlist=true" v-if="editService.companyName==''">
							Add company
						</el-button>
						<div v-else>
							<el-input readonly v-model="editService.companyName" style="width: 250px;" class="mr-10"></el-input>
							<el-button type="warning" @click="modalcustomerlist=true" icon="el-icon-edit" rounded>
							</el-button>
							<el-button type="danger" @click="handleDel" icon="el-icon-delete" rounded>
							</el-button>
						</div>
                        <!-- <el-select v-model="editService.companyName" placeholder="Select company" style="width:100%;">
                            <el-option
                            v-for="(item, key) in consumen"
                            :key="key"
                            :label="item.customer_name"
                            :value="item.customer_name">
                            </el-option>
                        </el-select> -->
                    </template>
                </el-form-item>
				<el-form-item label="FBBM ID">
					<el-row>
						<el-col :span="12">
							<el-select @change="handleselectfbbm" v-model="fbbm_id" filterable placeholder="Select FBBM ID" style="width:100%;">
									<el-option
									v-for="(item, key) in fbIdentintyFbbm"
									:key="key"
									:label="item.maskingName || '-'"
									:value="item">
									</el-option>
							</el-select>
						</el-col>
						<el-col :span="12"><el-input disabled v-model="fbbm_name" ></el-input></el-col>
					</el-row>
                </el-form-item>

				<el-form-item label="WABA ID *">
					<el-row>
						<el-col :span="12">
							<el-select @change="handleselectwaba" v-model="waba_id" filterable placeholder="Select WABA ID" style="width:100%;">
									<el-option
									v-for="(item, key) in fbIdentintyWaba"
									:key="key"
									:label="item.maskingName || '-'"
									:value="item">
									</el-option>
							</el-select>
						</el-col>
						<el-col :span="12"><el-input disabled v-model="waba_name" ></el-input></el-col>
					</el-row>
				</el-form-item>
                <el-form-item label="Service Name *">
                    <el-input v-model="editService.name" placeholder="Service name"></el-input>
                </el-form-item>
				<el-form-item label="Phone Number *">
                    <el-input v-model="editService.phone_number" placeholder="Phone number"></el-input>
                </el-form-item>
				<el-form-item label="Disable Check Contact">
                    <el-radio-group v-model="editService.disable_check_contact">
						<el-radio :label="`true`">True</el-radio>
						<el-radio :label="`false`">False</el-radio>
					</el-radio-group>
                </el-form-item>
				<el-form-item label="Server *">
                    <el-radio-group v-model="server">
						<el-radio :label="`dkd`">DKD</el-radio>
						<el-radio :label="`cloud`">Cloud</el-radio>
						<el-radio :label="`on_client`">On Client</el-radio>
					</el-radio-group>
                </el-form-item>
				
				<el-form-item v-if="server != 'cloud'" label="Service IP *">
                    <el-input v-model="editService.ip" placeholder="Insert service ip"></el-input>
                </el-form-item>

				<el-form-item v-if="server != 'cloud'" label="Service Port *">
                    <el-input v-model="editService.port" placeholder="Insert service port"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="updateService" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisibleEdit=false, clear()">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
		

		<el-card>
			<div slot="header" class="clearfix mb-10">
				<el-button type="primary" @click="dialogFormVisible = true, clear()">+ Add Service</el-button>
				<el-input
					style="width:auto; float:right;"
					prefix-icon="el-icon-search"
					placeholder="Search Service"
					clearable
					v-model="filterInput">
				</el-input>
			</div>
			<template>
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateService"
					:current-page="currentPage"
					:total="parseInt(totalService)">
				</el-pagination>
				<el-table :data="pagedTableData" style="width: 100%;" v-loading="loadingTemplate">
				<el-table-column prop="phone_number" label="Phone Number" width="250" fixed="left">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.phone_number || '-' }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="Service Name" width="250" fixed="left">
						<template slot-scope="props">
							<p v-if="props.row.name=='' || props.row.name==null" style="font-weight:bold;">-</p>
							<p v-else style="font-weight:bold;">{{ props.row.name }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="waba_id" label="WABA ID" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.waba_id || '-' }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="server" label="Server" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.server ? props.row.server.toUpperCase() : '-' }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="host" label="Service Host/IP" width="250">
						<template slot-scope="props">
							<p v-if="props.row.host=='' || props.row.host==null" style="font-weight:bold;">-</p>
							<p v-else style="font-weight:bold;">{{ props.row.host }}</p>
						</template>
					</el-table-column>
					
					<el-table-column prop="port" label="Service Port" width="200">
						<template slot-scope="props">
							<p v-if="props.row.port=='' || props.row.port==null" style="font-weight:bold;">-</p>
							<p v-else style="font-weight:bold;">{{ props.row.port }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="available" label="Service Available" width="590">
						<template slot-scope="props">
							<p v-if="props.row.available=='' || props.row.available==null" style="font-weight:bold;">-</p>
							<el-tag type="primary" size="large" v-else style="font-weight:bold; font-size:14px;">{{ props.row.available }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="date_created" label="Created At" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.date_created, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column label="#" width="100">
						<template slot-scope="props">
							<el-button size="small" type="info" @click="editData(props.row)">Edit</el-button>
						</template>
					</el-table-column>
				</el-table>
				<br/>
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateService"
					:current-page="currentPage"
					:total="parseInt(totalService)">
				</el-pagination>
			</template>
			<!-- <el-alert description="Maintenance to get list service, you can try to add service. Thank you" type="info" :closable="false" title="Information" show-icon></el-alert> -->
		</el-card>
		<!-- <el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card> -->
		<!-- <el-card class="mt-10"> -->
			<!-- <el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateService"
				:current-page="currentPage"
				:total="parseInt(totalService)">
			</el-pagination> -->
		<!-- </el-card> -->
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
// import moment from 'moment-timezone'
const moment = require('moment')

export default {
	name: 'WA_Connect',
	data () {
		return {
			detailCompany:null,
			editService:{},
			waba_id:"",
			fbbm_id:"",
			waba_name: "",
			fbbm_name: "",
			server:"dkd",
			disable_check_contact: 'false',
			fbIdentintyWaba:[{maskingName:"-", identityNumber: "", id:null}],
			fbIdentintyFbbm:[{maskingName:"-", identityNumber: "", id:null}],
			dialogFormVisibleEdit: false,
			passwordVisible:false,
			services:[],
			loadingTemplate: false,
			listServices: [],
			filterInput: '',
			oldPage: 0,
			currentPage: 1,
			pageSize: 10,
			total:'',
			totalService:'',
			dialogFormVisible:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			service:{
				companyName: '',
				name:'',
				port:'',
				password: config.passwordService,
				passwordFieldType: 'password',
				ip:'',
				limit: '',
				phone_number: "",
				disable_check_contact: 'false'
			},
			editService:{
				companyName: '',
				name:'',
				port:'',
				password: '',
				passwordFieldType: 'password',
				ip:'',
				limit: '',
				phone_number: "",
				disable_check_contact: 'false'
			},
			consumen: [],
			consumenList: [],
			selectedConsumen: '',
			modalcustomerlist: false,
			timeout:null,
			searchCustomer:this.$route.query.query || "",
			currentConsumenPage: parseInt(this.$route.query.page) || 1,
		}
	},
	computed: {
		pagedTableData() {
			return this.services.slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
		}
	},
	watch: {
		filterInput: function() {
			if (this.filterInput) {
				const value= this.filterInput.toLowerCase()
				this.services = this.listServices.filter(function(service) {
					return (service.name && service.name.toLowerCase().includes(value)) || 
						(service.host && service.host.toLowerCase().includes(value)) ||
						(service.port && service.port.toString().includes(value))
				})
				this.totalService = this.services.length
				if (!this.oldPage) {
					this.oldPage = this.currentPage
				}
				this.currentPage = 1
			} else {
				this.services = this.listServices
				if (this.oldPage) {
					this.currentPage = this.oldPage
					this.oldPage = 0
				}	
				this.totalService = this.listServices.length
			}
		},
		listServices: function() {
			this.services = this.listServices
		}
	},
	methods: {
		async editData(val){
			this.editService.customer_id = val.customer_id || ""
			if (val.customer_id) {
				await this.loadConsumenDetail(val.customer_id)
				this.editService.companyName = this.detailCompany ? this.detailCompany.customer_name:""
			}

			this.editService.name = val.name
			this.editService.ip = val.host
			this.editService.port = val.port
			this.editService.password = val.secret_key
			this.editService.disable_check_contact = val.disable_check_contact ? val.disable_check_contact : "false"
			this.server = val.server ? val.server: (val.cloud && val.cloud.phone_number_id ? "cloud" : "" )
			this.waba_id = val.waba_id || ""
			if (val.waba_id) {
				let waba = this.fbIdentintyWaba.find(el => el.identityNumber == val.waba_id)
				// this.waba_name = waba ? waba.maskingName : ""
			}
			this.fbbm_id = val.fbbm_id || ""
			if (val.fbbm_id) {
				let fbbm = this.fbIdentintyWaba.find(el => el.identityNumber == val.fbbm_id)
				// this.fbbm_name = fbbm ? fbbm.maskingName : ""
			}
			this.editService.phone_number = val.phone_number || ""
			this.dialogFormVisibleEdit = true
		},
		handleselectwaba(val){
			this.waba_id = val.identityNumber
		},
		handleselectfbbm(val){
			// this.fbbm_name = val.maskingName
			this.fbbm_id = val.identityNumber
		},
		async getFbIdentityAll(filter=""){
			await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					all: true,
					filter: filter
				}
			}).then(({ data }) => {
				// console.log("rasan rasan",data.data);
				const tempData =
					data &&
					data.data &&
					data.data.consumen
						? data.data.consumen
						: [];
				switch (filter) {
					case "waba_id":
						this.fbIdentintyWaba = this.fbIdentintyWaba.concat(tempData);
						break;
					case "fbbm_id":
						this.fbIdentintyFbbm = this.fbIdentintyFbbm.concat(tempData);
						// console.log("fbbm id",this.fbIdentintyFbbm)
						break;
				}
			}).catch(error => {
				console.log(error);
			})
		},
		handleChoose(index, row){
			console.log(index, row);
			// console.log('row',row.customer_name)
			this.service.companyName = row.customer_name
			this.service.customer_id = row.customer_id
			this.editService.companyName = row.customer_name
			this.editService.customer_id = row.customer_id
			this.modalcustomerlist = false
		},
		handleDel(){
			this.service.companyName = ''
			this.service.customer_id = ''
			this.editService.companyName = ''
			this.editService.customer_id = ''
		},
		querySearch(queryString, cb) {
			var links = this.consumen;
			var results = queryString ? links.filter(this.createFilter(queryString)) : links;
			// call callback function to return suggestion objects
			cb(results);
		},
		createFilter(queryString) {
			return (link) => {
			return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			};
		},
		switchVisibility(){
			this.service.passwordFieldType = this.service.passwordFieldType === 'password' ? 'text' : 'password'
		},
		buildQueryParam(key = null, val = null){
			// let q = window.location.search.split("?")
			// q.shift()
			// console.log(q)
			// if(q.length < 1){
			// 	q = { [key]: val }
			// } else {
			// 	_.map(q[0].split("&"), (val, key) => {
			// 		let [k, v] = val.split("=")
			// 		q.push({ [k]: v })
			// 	})
			// }
			// console.log(q)
			// let query =_.map(q, (val, key) => {
			// 	return { key: key, value: val }
			// })
			// if(key != null) {
			// 	let index = _.findIndex(query, v => v.key == key)
			// 	if(index !== -1){
			// 		query[index] = { key: key, value: val }
			// 	} else {
			// 		query.push({ key: key, value: val })
			// 	}
			// }
			// query = query.filter(v => { return v.value != null && v.value != "" })
			// // this.$route.query[key] = val
			// window.history.replaceState(null, null, "?" + query.map((v, k) => { return v.key + "=" + v.value }).join("&"));
		},
		doSearchCustomer(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.buildQueryParam("query", this.searchCustomer)
				this.loadConsumen()
			}, 1000)
		},
		async doGetSearchCustomer(query = "", page = 1){
	    //   this.loadingConsumen = true
	      await api({
	        method: 'get',
	        url:config.baseApi+'consumen',
	        params:{
	        	query: query,
				page: this.currentConsumenPage,
				customer_type: 2
	        }
	      }).then(result => {
	        this.consumen = result.data.data.consumen
	        // console.log(this.consumen);
	        // console.log('this consumen',this.consumen)
	        this.loadingConsumen = false
	      }).catch(error => {
	        console.error("Failed : " + error);
	        // this.loadingConsumen = false
	      })
	    },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		async addService(){
			
			if (this.server != 'cloud') {
				if(_.isEmpty(this.service.name) || !this.service.port || _.isEmpty(this.service.ip) || _.isEmpty(this.service.customer_id) || _.isEmpty(this.service.phone_number) || !this.waba_id || _.isEmpty(this.server)){
					this.$message.error({
							showClose: false,
							message: 'All field is required'
					});
					return
				}
			}
			else {
				
				if(_.isEmpty(this.service.name) || _.isEmpty(this.service.customer_id) || _.isEmpty(this.service.phone_number) || !this.waba_id || _.isEmpty(this.server)){
					this.$message.error({
							showClose: false,
							message: 'All field is required'
					});
					return
				}

				this.service.port = ""
				this.service.ip = ""
			}

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'service/add',
				method:'POST',
				data:{
                    sendOtp: this.server == 'cloud' ? true:false, //true
                    cert: "", // ""
                    server: this.server, // "cloud"
                    waba_id : this.waba_id,
                    fbbm_id: this.fbbm_id,
                    phone_number: this.service.phone_number,
                    customer_id: this.service.customer_id,
					companyName: this.service.companyName,
					name:this.service.name,
					port:this.service.port,
					password:this.service.password,
					ip:this.service.ip,
					disable_check_contact:this.service.disable_check_contact,
				}
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogFormVisible = false
					this.clear()
				}
				this.loadingBtn = false
				this.dialogFormVisible = false
			}).catch(error => {
				this.loadingBtn = false
				this.dialogFormVisible = false
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.clear()
				return error
			})
		},
		async getService(page = 1){
			this.loadingTemplate = true
			var self = this
			await api({
				url:config.baseApi+'service?page=' + page,
				method:'post'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.listServices = response.data.data
					this.totalService = response.data.data.length
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async updateService(){
			console.log(this.editService);
			console.log(this.waba_id);
			console.log(this.server);

			if (this.server != 'cloud') {
				// console.log(_.isEmpty(this.editService.name),!this.editService.port,_.isEmpty(this.editService.ip),_.isEmpty(this.editService.customer_id),_.isEmpty(this.editService.phone_number),_.isEmpty(this.waba_id),_.isEmpty(this.server));
				if(_.isEmpty(this.editService.name) || !this.editService.port || _.isEmpty(this.editService.ip) || _.isEmpty(this.editService.customer_id) || _.isEmpty(this.editService.phone_number) ||  _.isEmpty(this.waba_id) || _.isEmpty(this.server)){
					console.log('masuk');
					this.$message.error({
							showClose: false,
							message: 'All field is required'
					});
					return
				}
			}
			else {
				if(_.isEmpty(this.editService.name) || _.isEmpty(this.editService.customer_id) || _.isEmpty(this.editService.phone_number) ||  _.isEmpty(this.waba_id) || _.isEmpty(this.server)){
					this.$message.error({
							showClose: false,
							message: 'All field is required'
					});
					return
				}
			}
			// else {
			// 	this.editService.port = ""
			// 	this.editService.ip = ""
			// }

			// if (this.editService.name.substring(0, 2) != '62') {
			// 	this.$message.error({
			// 			showClose: false,
			// 			message: 'First character must be 62'
			// 	});
			// 	return
			// }

			// if (this.editService.phone_number.substring(0, 1) != '0') {
			// 	this.$message.error({
			// 			showClose: false,
			// 			message: 'First character must be 0'
			// 	});
			// 	return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'service/edit',
				method:'POST',
				data:{
                    sendOtp: this.server == 'cloud' ? true:false, //true
                    cert: "", // ""
                    server: this.server, // "cloud"
                    waba_id : this.waba_id,
                    fbbm_id: this.fbbm_id,
                    phone_number: this.editService.phone_number,
                    customer_id: this.editService.customer_id,
					companyName: this.editService.companyName,
					name:this.editService.name,
					port:this.editService.port,
					password:this.editService.password,
					ip:this.editService.ip,
					disable_check_contact:this.editService.disable_check_contact,
				}
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogFormVisibleEdit = false
					this.clear()
					this.getService()
					// this.getAllHSM()
				}
				this.loadingBtn = false
				this.dialogFormVisibleEdit = false
			}).catch(error => {
				this.loadingBtn = false
				this.dialogFormVisibleEdit = false
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.clear()
				return error
			})
		},
		async loadConsumen(page = 1,){
			// this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'consumen',
				method:'GET',
				params: {
					page: page,
					query: this.searchCustomer,
					customer_type: 2
				}
				
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.consumen = response.data.data.consumen
					this.total = response.data.data.total
				}
			}).catch(error => {
				// console.log("Error",error)
			})
			// this.loadingConsumen = false
		},
		async loadConsumenDetail(customer_id = ""){
			// this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'consumen/' + customer_id,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.detailCompany = response.data.data.consumen || null
					// console.log("consumen",this.consumen)
					// this.consumen.forEach(element => {
					// 	console.log('customer name :',element.customer_name)
					// 	if(element.customer_name!=null){
					// 		this.consumenList.push(element.customer_name)
					// 		// console.log('list konsumen',this.consumenList)
					// 	}
					// });
					// let dp_user = []
					// this.consumen = _.orderBy(consumen, function(o) { return new moment(o.created_at); }, ['desc']);

					// if(this.filter.btnStatus){
					// 	this.consumen = consumen
					// 	this.total = response.data.data.total
					// 	// console.log(this.consumen)
					// }
				}
			}).catch(error => {
				// console.log("Error",error)
			})
			// this.loadingConsumen = false
		},
		async paginateService(page){
			this.currentPage = page
			/* await this.getService(this.currentPage) */
		},
		async paginateConsumen(page){
			this.currentConsumenPage = page
			this.buildQueryParam("page", page)
			await this.loadConsumen(this.currentConsumenPage)
		},
		clear(){
			this.service.customer_id = ""
			this.service.companyName = ""
			this.service.name = ""
			this.service.port = ""
			this.service.password = ""
			this.service.ip = ""
			this.editService.customer_id = ""
			this.editService.companyName = ""
			this.editService.name = ""
			this.editService.port = ""
			this.editService.password = ""
			this.editService.ip = ""
			this.waba_id = ""
			this.waba_name = ""
			this.fbbm_id = ""
			this.fbbm_name = ""
			this.service.phone_number = ""
			this.editService.phone_number = ""
			this.server = "dkd"
			this.disable_check_contact = "false"
		}
	},
	async created(){
		this.getService()
		await this.getFbIdentityAll("waba_id")
		await this.getFbIdentityAll("fbbm_id")
		await this.loadConsumen()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
